// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9RhU-","content":"styles_content__vQlaO","row":"styles_row__3h4JM","footer":"styles_footer__1rH_F","phraseLength":"styles_phraseLength__uiBjl"};